import { Setting, settingsDB } from '../../models/setting'
import { toRaw } from 'vue'
import { createSetting, updateSetting, getAllSettings, getEnvironments } from '../../services/setting'
export const getSettings = async () => {
  const settings = await getAllSettings()
  //const settings = await settingsDB.settings.get('settings')
  return settings
}

export const addSettings = async (setting: Setting) => {
  try {
    await createSetting(toRaw(setting))
    return true
    //await settingsDB.settings.add(toRaw(setting))
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const updateSettingAPI = async (setting: Setting) => {
  try {
    await updateSetting(toRaw(setting))
    return true
    //await settingsDB.settings.update(setting.id, toRaw(setting))
  } catch (e) {
    throw e
  }
}

export const getAPIEnvironments = async () => {
  try {
    return await getEnvironments()
    return true
  } catch (e) {
    throw e
  }
}
